import { useCallback, useMemo } from "react";
import ChecklistItem from "@coworker/apprestructured/src/task-management/types/ChecklistItem";
import CompletableChecklistItem from "@coworker/apprestructured/src/task-management/components/CompletableChecklist/CompletableChecklistItem/CompletableChecklistItem";
import CountedProgress from "@coworker/apprestructured/src/task-management/components/CountedProgress/CountedProgress";
import styles from "./CompletableChecklist.module.css";

type CompletableChecklistProps = {
  items: ChecklistItem[];
  onItemsChange: (newItems: ChecklistItem[]) => void;
  label: string;
  disabled: boolean;
};

function CompletableChecklist({
  items,
  onItemsChange,
  label,
  disabled,
}: CompletableChecklistProps) {
  const handleCompletedChange = useCallback(
    (i: number, newCompleted: boolean) => {
      const newItems = items.map((item, itemIndex) =>
        itemIndex === i ? { ...item, completed: newCompleted } : item
      );
      onItemsChange(newItems);
    },
    [items, onItemsChange]
  );

  const nbrOfCompletedItems = useMemo(() => {
    return items.filter(({ completed }) => completed).length;
  }, [items]);

  if (items.length === 0) {
    return null;
  }

  return (
    <div className={styles["root"]}>
      <CountedProgress
        label={label}
        max={items.length}
        count={nbrOfCompletedItems}
      />
      <ul className={styles["ul"]}>
        {items.map(({ title, completed }, i) => {
          return (
            <CompletableChecklistItem
              key={i}
              title={title}
              completed={completed}
              onCompletedChange={(newCompleted) =>
                handleCompletedChange(i, newCompleted)
              }
              disabled={disabled}
            />
          );
        })}
      </ul>
    </div>
  );
}

export default CompletableChecklist;
